import { findGetParameter } from "../components/utilities/UtilityFunctions";
import { Navigate } from "react-router-dom";
import ModalLoadingFull from "../components/modals/ModalLoadingFull";
import LoginRedirect from "../pages/user/Login/LoginRedirect";
import MainLayout from "../components/layout/MainLayout";
import NotFound from "../pages/utility/NotFound";
import StoreAdminOrders from "../pages/storeAdmin/StoreAdminOrders";
import StoreAdminOrder from "../pages/storeAdmin/StoreAdminOrder";
import StoreAdminProducts from "../pages/storeAdmin/StoreAdminProducts";
import StoreAdminProduct from "../pages/storeAdmin/StoreAdminProduct";
import StoreAdminCategories from "../pages/storeAdmin/StoreAdminCategories";
import StoreAdminCategory from "../pages/storeAdmin/StoreAdminCategory";
import StoreAdminIndex from "../pages/storeAdmin/StoreAdminIndex";
import Admin from "../pages/admin/Admin";
import Utilities from "../pages/admin/Utilities";
import CardAdmin from "../pages/cards/CardAdmin";
import AdminDashboard from "../pages/admin/AdminDashboard";
import { getEnvironmentVariable } from "../global/environmentVariables";

export const adminRoutes = (authContext, itemsMiddle, setItemsMiddle) => {
  const forceLoginParam = findGetParameter("forceLogin");

  return [
    {
      path: "admin",
      element:
        !authContext?.authState || authContext?.authState?.isLoading ? (
          <ModalLoadingFull />
        ) : authContext?.authState?.identity?.isAdmin !== true &&
          !authContext?.authState?.identity?.adminGameSystems?.length ? (
          <Navigate to="/access-denied" />
        ) : forceLoginParam?.toLowerCase() === "true" &&
          !authContext?.authState?.isAuthenticated ? (
          <LoginRedirect />
        ) : (
          <MainLayout
            authContext={authContext}
            itemsMiddle={itemsMiddle}
            setItemsMiddle={setItemsMiddle}
            admin={
              getEnvironmentVariable("SUPPORTS_LOYALTY_STORE") === "true" ||
              getEnvironmentVariable("SUPPORTS_PRODUCTS") === "true"
            }
          />
        ),
      children: [
        {
          path: "shop/transactions",
          element:
            getEnvironmentVariable("SUPPORTS_LOYALTY_STORE") !== "true" ? (
              <NotFound />
            ) : authContext?.authState?.isAuthenticated ? (
              <StoreAdminOrders setItemsMiddle={setItemsMiddle} />
            ) : (
              <LoginRedirect />
            ),
        },
        {
          path: "shop/transaction",
          element:
            getEnvironmentVariable("SUPPORTS_LOYALTY_STORE") !== "true" ? (
              <NotFound />
            ) : authContext?.authState?.isAuthenticated ? (
              <StoreAdminOrder setItemsMiddle={setItemsMiddle} />
            ) : (
              <LoginRedirect />
            ),
        },
        {
          path: "shop/transaction/:transactionId",
          element:
            getEnvironmentVariable("SUPPORTS_LOYALTY_STORE") !== "true" ? (
              <NotFound />
            ) : authContext?.authState?.isAuthenticated ? (
              <StoreAdminOrder setItemsMiddle={setItemsMiddle} />
            ) : (
              <LoginRedirect />
            ),
        },
        {
          path: "shop/products",
          element:
            getEnvironmentVariable("SUPPORTS_LOYALTY_STORE") !== "true" &&
            getEnvironmentVariable("SUPPORTS_PRODUCTS") !== "true" ? (
              <NotFound />
            ) : authContext?.authState?.isAuthenticated ? (
              <StoreAdminProducts setItemsMiddle={setItemsMiddle} />
            ) : (
              <LoginRedirect />
            ),
        },
        {
          path: "shop/product/:productId",
          element:
            getEnvironmentVariable("SUPPORTS_LOYALTY_STORE") !== "true" &&
            getEnvironmentVariable("SUPPORTS_PRODUCTS") !== "true" ? (
              <NotFound />
            ) : authContext?.authState?.isAuthenticated ? (
              <StoreAdminProduct setItemsMiddle={setItemsMiddle} />
            ) : (
              <LoginRedirect />
            ),
        },
        {
          path: "shop/product",
          element:
            getEnvironmentVariable("SUPPORTS_LOYALTY_STORE") !== "true" &&
            getEnvironmentVariable("SUPPORTS_PRODUCTS") !== "true" ? (
              <NotFound />
            ) : authContext?.authState?.isAuthenticated ? (
              <StoreAdminProduct setItemsMiddle={setItemsMiddle} />
            ) : (
              <LoginRedirect />
            ),
        },

        {
          path: "shop/categories",
          element:
            getEnvironmentVariable("SUPPORTS_LOYALTY_STORE") !== "true" &&
            getEnvironmentVariable("SUPPORTS_PRODUCTS") !== "true" ? (
              <NotFound />
            ) : authContext?.authState?.isAuthenticated ? (
              <StoreAdminCategories setItemsMiddle={setItemsMiddle} />
            ) : (
              <LoginRedirect />
            ),
        },
        {
          path: "shop/category/:categoryId",
          element:
            getEnvironmentVariable("SUPPORTS_LOYALTY_STORE") !== "true" &&
            getEnvironmentVariable("SUPPORTS_PRODUCTS") !== "true" ? (
              <NotFound />
            ) : authContext?.authState?.isAuthenticated ? (
              <StoreAdminCategory setItemsMiddle={setItemsMiddle} />
            ) : (
              <LoginRedirect />
            ),
        },
        {
          path: "shop/category",
          element:
            getEnvironmentVariable("SUPPORTS_LOYALTY_STORE") !== "true" &&
            getEnvironmentVariable("SUPPORTS_PRODUCTS") !== "true" ? (
              <NotFound />
            ) : authContext?.authState?.isAuthenticated ? (
              <StoreAdminCategory setItemsMiddle={setItemsMiddle} />
            ) : (
              <LoginRedirect />
            ),
        },
        {
          path: "shop",
          element:
            getEnvironmentVariable("SUPPORTS_LOYALTY_STORE") !== "true" &&
            getEnvironmentVariable("SUPPORTS_PRODUCTS") !== "true" ? (
              <NotFound />
            ) : authContext?.authState?.isAuthenticated ? (
              <StoreAdminIndex setItemsMiddle={setItemsMiddle} />
            ) : (
              <LoginRedirect />
            ),
        },
      ],
    },
    {
      path: "admin",
      element:
        !authContext?.authState || authContext?.authState?.isLoading ? (
          <ModalLoadingFull />
        ) : authContext?.authState?.identity?.isAdmin !== true &&
          !authContext?.authState?.identity?.adminGameSystems?.length ? (
          <Navigate to="/access-denied" />
        ) : forceLoginParam?.toLowerCase() === "true" &&
          !authContext?.authState?.isAuthenticated ? (
          <LoginRedirect />
        ) : (
          <MainLayout
            authContext={authContext}
            itemsMiddle={itemsMiddle}
            setItemsMiddle={setItemsMiddle}
            admin
          />
        ),
      children: [
        {
          path: "settings",
          element: <Admin />,
        },
        {
          path: "utilities",
          element: <Utilities />,
        },
        {
          path: "card/:cardId",
          element: <CardAdmin />,
        },
        {
          path: "/admin/",
          element: <AdminDashboard />,
        },
      ],
    },
  ];
};
